import { render, staticRenderFns } from "./ConsultResponseV3List.vue?vue&type=template&id=cd6ac1fa&"
import script from "./ConsultResponseV3List.vue?vue&type=script&lang=ts&"
export * from "./ConsultResponseV3List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports